import * as moment from 'moment';

export enum SearchDateOptions {
  PayPeriod = 'payPeriod',
  DateRange = 'dateRange'
}

export interface DateRangeOutput {
  type: 'start' | 'end' | 'all';
  value: Date | string;
}

export interface SplitSearchButtonItem {
  text: string;
  icon: string;
  click: () => void;
  disabled?: boolean;
  view: View;
  isVisible: (staff: StaffDTO) => boolean;
}

export interface TimeSheet {
  timeSheetIdx: string;
  timeSummaryIdx: number;
  staffID: number;
  staffName?: string;
  dateWorked: Date | string;
  startTime: Date | string;
  endTime?: Date | string;
  hoursWorked?: number;
  hoursBreak?: number;
  hoursBillable?: number;
  descriptionOfService: string;
  chargeToClient?: boolean;
  clientID: number;
  clientName?: string;
  billingDescription?: number | string;
  deleted: boolean;
}


export enum UserRole {
  Admin = 2,
  User = 1,
}

export enum View {
  detail = 'detail',
  summary = 'summary',
  categories = 'categories',
  descriptions = 'descriptions',
  staff = 'staff',
  clients = 'clients'
}

export interface Month {
  abbreviation: string;
  name: string;
  index: string;
}

export interface Message {
  type: 'info' | 'success' | 'danger' | 'warning';
  content: string;
  title?: string;
  id?: string;
}

export interface DateRange {
  DateStarting: Date | string;
  DateEnding: Date | string;
}

export interface SearchByOptions {
  dateOption: SearchDateOptions;
  client: ClientDTO;
  month?: Month;
  payPeriod ?: PayPeriod;
  dateRange ?: DateRange;
  staff: StaffDTO;
  category?: Category;
  staffCodes?: StaffCodeDTO[];
}

export interface PayPeriodDTO {
  payPeriodEndingIdx: number;
  payPeriodStarting: string;
  payPeriodEnding: string;
}

export interface PayPeriod {
  text: string;
  payPeriodEndingIdx: number;
  payPeriodStarting: Date | string;
  payPeriodEnding: Date | string;
  index?: number;
}

export interface TTMap<T> {
  [index: string]: T;
}

export interface StaffDTO {
  staffID: number;
  username: string;
  staffName: string;
  staffType: string;
  corpToCorp?: boolean;
  corpName?: string;
  active: boolean;
  emailAddress: string;
  userRole: number;
  timeOffAllowed?: number;
  employStartDate?: Date;
  employTermDate?: Date;
  mainRoleType?: string;
  partTime: boolean;
  hourly: boolean;
  hourlyExpectedHours?: number;
  isCurrentUserAdmin: boolean;
  isCurrentUser: boolean;
}

export interface StaffCodeDTO {
  description: string;
  timeTrackerCode: string;
  displayCode: string;
}

export interface ClientDTO {
  clientID: number;
  clientName: string;
  invoiceName?: string;
  reportName?: string;
  emailSubjectName?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  billTo?: string;
  categorizeBilling?: boolean;
  active?: boolean;
  emailAddress?: string;
}

export interface Category {
  categoryID: number;
  clientID: number;
  clientName?: string;
  category: string;
}

export interface Description {
  descriptionID: number;
  clientID: number;
  clientName?: string;
  description: string;
  categoryID: number;
  category?: string;
  active: boolean;
  viewInAdminScreen?: boolean;
}

export interface TimeSummaryRow {
  id: number;
  timeSummaryIdx: number;
  clientID: number;
  clientName: string;
  staffID: number;
  staffName: string;
  payPeriodStarting: Date | string;
  payPeriodEnding: Date | string;
  hoursBreak: number;
  hoursBillable: number;
  submittedDate: Date | string;
  locked: boolean;
}

export interface TimeSummary {
  timeSummaryIdx: number;
  staffID: number;
  clientID: number;
  payPeriodStarting: Date | string;
  payPeriodEnding: Date | string;
  totalHoursBillable: number;
  submittedDate: Date | string;
  locked: boolean;
}

export interface PTO {
  staffID: number;
  isViewable: boolean;
  timeOffAllowed: number;
  timeOffUsed: number;
  timeOffRemaining: number;
}

export function formatTimesheetForRequest(sheet: TimeSheet): TimeSheet {
  const dto = {...sheet} as any;
  dto.dateWorked = moment(sheet.dateWorked).format('MM/D/YYYY');
  dto.startTime = moment(sheet.startTime).format('MM/D/YYYY h:mmA');
  dto.endTime = moment(sheet.endTime).format('MM/D/YYYY h:mmA');
  return dto;
}

export const StatesData:Array<string> =
["AK","AL","AR","AS","AZ",
 "CA","CO","CT","DC","DE",
 "FL","FM","GA","GU","HI",
 "IA","ID","IL","IN","KS",
 "KY","LA","MA","MD","ME",
 "MH","MI","MN","MO","MP",
 "MS","MT","NC","ND","NE",
 "NH","NJ","NM","NV","NY",
 "OH","OK","OR","PA","PR",
 "PW","RI","SC","SD","TN",
 "TX","UT","VA","VI","VT",
 "WA","WI","WV","WY"]